export default class SchoolProfileService {
  constructor(http) {
    this.http = http;
  }

  async getAdminProfile(schoolid) {
    const query = new URLSearchParams();
    if (schoolid) query.set("schoolid", String(schoolid));
    return this.http.fetch(`/api/school-profile/me?${query.toString()}`, {
      method: "GET",
    });
  }

  async upsertAdminProfile(payload) {
    return this.http.fetch("/api/school-profile/me", {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  }

  async getPublicProfileBySchoolId(schoolid) {
    return this.http.fetch(`/api/school-profile/${encodeURIComponent(schoolid)}`, {
      method: "GET",
    });
  }
}
